import { defineMessages, type MessageDescriptor } from 'react-intl-next';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	undo: {
		id: 'editor-plugin-ai.SessionUI.screens.PostStreamReview.undo',
		defaultMessage: 'Undo',
		description: 'Label for the undo button in the post-stream review toolbar.',
	},
	redo: {
		id: 'editor-plugin-ai.SessionUI.screens.PostStreamReview.redo',
		defaultMessage: 'Redo',
		description: 'Label for the redo button in the post-stream review toolbar.',
	},
	viewChanges: {
		id: 'editor-plugin-ai.SessionUI.screens.PostStreamReview.viewChanges',
		defaultMessage: 'View changes',
		description: 'Label for the view changes button in the post-stream review toolbar.',
	},
	thumbsUp: {
		id: 'editor-plugin-ai.SessionUI.screens.PostStreamReview.thumbsUp',
		defaultMessage: 'Good response',
		description: 'Label for the positive feedback button in the post-stream review toolbar.',
	},
	thumbsDown: {
		id: 'editor-plugin-ai.SessionUI.screens.PostStreamReview.thumbsDown',
		defaultMessage: 'Bad response',
		description: 'Label for the negative feedback button in the post-stream review toolbar.',
	},
	takeToStaging: {
		id: 'editor-plugin-ai.SessionUI.screens.PostStreamReview.takeToStaging',
		defaultMessage: 'Take to staging area',
		description:
			'Label for the button that moves AI-generated changes to a full-page staging editor.',
	},
	previousChange: {
		id: 'editor-plugin-ai.SessionUI.screens.PostStreamReview.previousChange',
		defaultMessage: 'Previous change',
		description:
			'Label for the previous-segment navigation button in the post-stream review toolbar.',
	},
	nextChange: {
		id: 'editor-plugin-ai.SessionUI.screens.PostStreamReview.nextChange',
		defaultMessage: 'Next change',
		description:
			'Label for the next-segment navigation button in the post-stream review toolbar.',
	},
});
